// @ts-nocheck
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

export interface ShareEmailInterface extends ApiParameter {
    ReportUrl: string;
    Email: string;
}

export function getReportByUrl(url: string) {
    return get<any>(`${url}`);
}

export function shareEmail(parameter: ShareEmailInterface) {
    return post<any>("/api/v1/coolcalc/sharereport", {
        ReportUrl: parameter.ReportUrl,
        Email: parameter.Email,
    });
}
